import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../contex/AuthProvider";
import CheckTerms from "../../molecules/CheckTerms";
import CustomInput from "../../molecules/CustomInput";
import GoogleAuthentication from "../../molecules/GoogleAuthentication";
import PasswordInput from "../../molecules/PasswordInput";
import PinkButton from "../../molecules/PinkButton";

const AuthForm = () => {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const { register, handleSubmit, control } = useForm();
  const [passValues, setPassValues] = useState({
    password: "",
    showPassword: false,
  });
  const [newUser, setNewUser] = useState(true);
  const onSubmit = (data) => {
    data["password"] = passValues.password;

    if (!newUser) {
      auth.signin(data, () => navigate("/"));
    } else {
      auth.handleRegister(data, () => navigate("/"));
    }
    // auth.signin(data, () => navigate("/"));
    console.log(data);
  };
  return (
    <div className="m-auto md:min-h-screen w-5/6 md:w-1/4 mt-10 md:mt-28">
      <form onSubmit={handleSubmit(onSubmit)}>
        {newUser && (
          <>
            <CustomInput
              register={register}
              id="firstName"
              required={true}
              type="text"
              placeholder="first name"
            />
            <CustomInput
              register={register}
              id="lastName"
              required={true}
              type="text"
              placeholder="last name"
            />
          </>
        )}
        <CustomInput
          register={register}
          id="email"
          required={true}
          type="email"
          placeholder="email"
        />
        <PasswordInput
          id="password"
          placeholder="password"
          register={register}
          values={passValues}
          setValues={setPassValues}
        />
        {newUser && <CheckTerms control={control} />}
        <PinkButton text="sign up" />
      </form>
      <GoogleAuthentication />

      <div className="text-center text-md md:text-lg mt-4">
        <p className="text-grey">
          {newUser ? "already have an account?" : "create a new account?"}
          <span
            className="pl-2 text-red underline
           cursor-pointer"
            onClick={() => setNewUser(!newUser)}
          >
            {newUser ? "login" : "register"}
          </span>
        </p>
      </div>
    </div>
  );
};

export default AuthForm;
